<template>
  <menu-item-abs type="entree"/>
</template>

<script>
import MenuItemAbs from "./MenuItemAbs";
export default {
  name: "Entree-List",
  components: {
    MenuItemAbs
  },
  data: () => ({
  }),
  methods: {
  }
};
</script>
